import RepeatIcon from 'components/material-symbol/icons/Repeat'
import AttachMoneyIcon from 'components/material-symbol/icons/AttachMoney'
import LibraryBooksIcon from 'components/material-symbol/icons/LibraryBooks'

export const METRIC_ICONS = {
  'revenue-per-student': AttachMoneyIcon,
  'student-retention': RepeatIcon,
  'lesson-pack-attach': LibraryBooksIcon,
}

export const getMetricIcon = metricId => METRIC_ICONS[metricId] || null
